<span
  [style.display]="displayCss"
  [pTooltip]="tooltip"
  life="3"
  showDelay="500"
  tooltipPosition="top"
  tooltipZIndex="2100"
  [style.margin-top.px]="data && data.marginTop > 0 ? data.marginTop : null"
  [style.backgroundColor]="backgroundColorCss"
>
  <label
    *ngIf="this.inputRef && isLabelDisplay && label !== undefined && label !== null && label.trim().length > 0"
    [style.font-size]="overridedCSS?.labelFontSize"
    >{{ label | textLimit: this.inputRef.nativeElement.clientWidth / 7 }}</label
  >
  <div class="input-number-body">
    <input
      #input
      *ngIf="!multiple"
      class="iu-number-input"
      onkeydown="javascript: return event.keyCode == 69 ? false : true"
      pInputText
      type="number"
      value=""
      (change)="!multiple && dataChange(_parseFloat(input.value))"
      (contextmenu)="!multiple && onContextMenu($event)"
      (keydown.enter)="!multiple && enterKey.emit($event)"
      (press)="!multiple && onContextMenu($event)"
      (blur)="!multiple && inputBlur.emit($event)"
      [(ngModel)]="fieldValue"
      [readonly]="isReadOnly ? 'disabled' : null"
      [tabindex]="isReadOnly ? '-1' : null"
      [max]="this.max"
      [min]="this.min"
      [ngClass]="[hasConflict ? 'iu-field-conflict-text' : '', 'quantity', 'ui-corner-all', mandatoryCss || '']"
      [step]="fieldStep"
      autocomplete="no"
      [style.font-size]="overridedCSS?.inputFontSize"
      [style.height]="overridedCSS?.inputHeight"
      data-cy="input-text"
      [attr.data-cy-columnName]="data ? data.columnName : columnName"
      placeholder="{{ placeHolder }}"
      lang="{{ lang }}"
      (wheel)="OnWheel($event)"
    />
    <iu-input-chips-ui
      #inputChips
      *ngIf="multiple"
      [cssClass]="'iu-number-input'"
      [inputType]="'number'"
      [addOnSpace]="true"
      [addOnEnter]="true"
      [isLabelDisplay]="false"
      [addOnBlur]="true"
      [editOnBackspace]="true"
      (fieldValueChange)="dataChange($event)"
      [(fieldValue)]="fieldValue"
      [matchPattern]="regexNB"
      [columnName]="data ? data.columnName : columnName"
    ></iu-input-chips-ui>
    <span
      [attr.disabled]="isReadOnly ? 'disabled' : null"
      *ngIf="!this.isCurrencyDisplay"
      #currencySpan
      class="icon-ico-number iconCurrency"
      [style.height]="overridedCSS?.inputHeight"
    >
    </span>
    <span [attr.disabled]="isReadOnly ? 'disabled' : null" *ngIf="this.isCurrencyDisplay" #currencySpan class="iconCurrency">{{
      this.currency
    }}</span>
  </div>
  <i
    *ngIf="hasConflict && dataStored"
    #spanInput
    class="ui-inputgroup-addon rtconflict fas fa-exclamation-triangle iconClass"
    (click)="showConflictPanel($event)"
  ></i>
  <iu-value-preference-panel
    *ngIf="showValuePrefPanel"
    [fieldValue]="fieldValue"
    [dataStored]="this.dataStored"
    [sourceComponent]="this"
    [data]="this.data"
    (closeEmitter)="showValuePrefPanel = !showValuePrefPanel"
  ></iu-value-preference-panel>
</span>

<p-overlayPanel #opConflict>
  <a class="data-conflict" (click)="chooseData($event, (dataStored?.data)[data.columnName], true); opConflict.hide($event)">{{
    (dataStored?.data)[data.columnName]
  }}</a>
  | <a class="data-conflict" (click)="chooseData($event, conflictedData, false); opConflict.hide($event)">{{ conflictedData }}</a>
</p-overlayPanel>
